<template>
  <div>
    <video
      autoplay
      loop
      muted
      playsinline
      id="bgvid"
      poster="../assets/typewriter-loading-image.svg"
      preload="metadata"
    >
      <source
        src="../assets/film-noir-typing-on-an-old-typewriter_ekvx-cing_1080__D.mp4"
        type="video/mp4"
      />
    </video>
    <div class="intro"></div>
    <div class="overlay">
      <div class="time-left title">
        <vac :end-time="moment(this.$props.countdownTime)">
          <h1 slot="process" slot-scope="{ timeObj }">
            Noch {{ timeObj.d }} Tage, {{ timeObj.h }} Stunden,
            {{ timeObj.m }} Minuten bis das Onlinezugangsgesetz vollständig
            umgesetzt sein muss und die 🇩🇪 Verwaltung digital ist.
          </h1>
          <span slot="finish">🇩🇪 ist digital!</span>
        </vac>
      </div>
      <div class="srsly">⬇️</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import vueAwesomeCountdown from "vue-awesome-countdown/src/vue-awesome-countdown";
Vue.use(vueAwesomeCountdown, "vac");
export default {
  props: ["countdown-time"],
  name: "Countdown"
};
</script>

<style scoped lang="scss">
video {
  object-fit: cover;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.intro {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  opacity: 0;
  color: #fff;
  z-index: 2;
  margin-bottom: 50px;
  .time-left {
    text-align: center;
    font-family: "Bitter", serif;
    font-size: 2rem;
    line-height: 3rem;
  }
}

.overlay {
  margin: 0 auto;
  padding: 0;
  height: 110vh;
  margin-top: -110vh;
  width: 100%;
  vertical-align: middle;
  position: relative;
  z-index: 100;

  padding-top: 20%;
  padding-left: 15%;
  padding-right: 15%;

  @media (max-width: 576px) {
    padding-top: 40%;
    padding-left: 5%;
    padding-right: 5%;
  }
}

@keyframes icon-pulse {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1.1);
  }
  70% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

.srsly {
  font-size: 10vh;
  text-align: center;
  margin-top: 20vh;
  animation: icon-pulse 3s infinite ease-out;
}
.title {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px;
  margin: 0 auto;
}

.title h1 {
  text-align: center;
  font-family: "Bitter", serif;
  font-weight: 500;
  font-size: 2.7rem;
  line-height: 3.5rem;
  @media (max-width: 576px) {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
</style>
